"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Toggle = require("./Toggle.style");
/* eslint-disable jsx-a11y/label-has-associated-control */


var Toggle = function Toggle(_ref) {
  var alignment = _ref.alignment,
      checked = _ref.checked,
      handleToggle = _ref.handleToggle,
      label = _ref.label,
      id = _ref.id,
      textPosition = _ref.textPosition;
  return /*#__PURE__*/_react.default.createElement(_Toggle.Wrapper, {
    alignment: alignment
  }, textPosition !== 'right' && /*#__PURE__*/_react.default.createElement(_Toggle.ToggleText, {
    "data-test": "textLeft"
  }, label), /*#__PURE__*/_react.default.createElement(_Toggle.ToggleCheckbox, {
    checked: checked,
    id: id,
    onChange: handleToggle,
    type: "checkbox"
  }), /*#__PURE__*/_react.default.createElement(_Toggle.ToggleLabel, {
    htmlFor: id
  }, /*#__PURE__*/_react.default.createElement(_Toggle.ToggleDot, null)), textPosition === 'right' && /*#__PURE__*/_react.default.createElement(_Toggle.ToggleText, {
    "data-test": "textRight"
  }, label));
};

Toggle.propTypes = {
  alignment: _propTypes.default.oneOf(['center', 'flex-start', 'flex-end']),
  checked: _propTypes.default.bool.isRequired,
  handleToggle: _propTypes.default.func.isRequired,
  id: _propTypes.default.string,
  label: _propTypes.default.string,
  textPosition: _propTypes.default.oneOf(['left', 'right'])
};
Toggle.defaultProps = {
  alignment: 'center',
  id: 'horizon-toggle',
  label: 'Switch',
  textPosition: 'left'
};
var _default = Toggle;
exports.default = _default;